import React from 'react';
import classnames from 'classnames';
import { useConfig } from './default-config';

interface AdvisorProps {
    description: string;
    isRightAnswer?: boolean;
}

const Advisor = ({ description, isRightAnswer }: AdvisorProps) => {
    const { advisorName } = useConfig().texts;
    return (
        <div className="advisor">
            <div
                className={classnames('advice', {
                    'theme-colors-lighter': isRightAnswer === undefined,
                    'correct-answer': isRightAnswer,
                    'wrong-answer': isRightAnswer === false
                })}
            >
                <span className="advice-text">
                    <span className="ikon" role="img" aria-hidden>
                        {isRightAnswer && '👍'}
                        {isRightAnswer === false && '👎'}
                        {isRightAnswer === undefined && '🥳 '}
                        &nbsp;
                    </span>
                    {description}
                </span>
            </div>
            <div className="consultant">
                <span className="advisor-text">{advisorName}</span>
                <span className="ikon ikon-radgiver-36" aria-hidden />
            </div>
        </div>
    );
};

export default Advisor;
